import type { CustomIconProps } from '../CustomIcon';

export function Sunrise(props: CustomIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_33_48)">
        <path
          d="M14.1666 14.9999C14.1666 13.8948 13.7276 12.835 12.9462 12.0536C12.1648 11.2722 11.105 10.8333 9.99992 10.8333C8.89485 10.8333 7.83504 11.2722 7.05364 12.0536C6.27224 12.835 5.83325 13.8948 5.83325 14.9999"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 1.66675V7.50008"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5166 8.5166L4.69993 9.69993"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.833252 15H2.49992"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 15H19.1667"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3 9.69993L16.4834 8.5166"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1666 18.3333H0.833252"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66675 5.00008L10.0001 1.66675L13.3334 5.00008"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_48">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
